import { useRecordContext } from "react-admin";
import { Student } from "../../providers/studentsProvider";
import { useBookedQuotes } from "../../hooks/useBookedQuotes";
import { StudentDrivingLessonsList } from "../student/StudentDrivingLessonsTab";
import { StudentTab } from "../student/StudentTab";

export function StudentDrivingLessonsTab2() {
  const student = useRecordContext<Student>();
  const { selectedBookedQuote } = useBookedQuotes(student);

  return (
    <StudentTab>
      <StudentDrivingLessonsList filter={{ bookedTrainingIds: selectedBookedQuote.bookedTrainingIds }} />
    </StudentTab>
  );
}
